import { api } from '../lib/api'

// Observatório da Lucro Digital (NovaLD), pelo backend (que guarda o token).

export interface ObservatorioNicho {
  slug: string
  nome: string
  publico: 'SERVICOS' | 'ECOMMERCE'
  status: 'ATIVO' | 'PROPOSTO'
  origem: string
  sinonimos: string[]
  // Ativo e com pacote na versão publicada (demanda e previsão disponíveis).
  noMapa: boolean
}

export interface ObservatorioGeo {
  id: number
  nome: string
  tipo: 'PAIS' | 'ESTADO' | 'CIDADE'
  uf: string | null
}

export interface ObservatorioCatalogo {
  versao: { semana: string; publicadaEm: string | null } | null
  nichos: ObservatorioNicho[]
  geos: ObservatorioGeo[]
}

export const observatorioApi = {
  catalogo: () => api.get<ObservatorioCatalogo>('/observatorio/catalogo'),
  pedirNicho: (data: {
    nome: string
    publico: 'SERVICOS' | 'ECOMMERCE'
    sinonimos: string[]
    clientName: string
  }) =>
    api.post<{ nicho: { slug: string; nome: string; status: string; origem: string }; criado: boolean }>(
      '/observatorio/nichos',
      data
    ),
}
